import Vue from 'vue';   
import { store } from '../store';
import moment from 'moment';
import { toNumber } from './formatNumber';
import DATA from './DATA';
let NAME = "EVENT-BUS"

export const EventBus = new Vue({
    data(){
        return{
             
            INPUT_TEXT : '',
            INPUT_SPACIAL_KEYS : [],
            INPUT_TIMER : true,
            INPUT_NEW_TEXT : true,
            KEY_DOWN_STARTED : false,
            KEY_UP_STARTED : false, 
        }
    },
    created(){ 
        this.keysPressed = {};
        this.ON_KEY_UP()
        this.ON_KEY_DOWN()
        this.ON_CLICK()
        this.ON_RIGHT_CLICK()
        this.ON_DOUBLE_CLICK()
        this.ON_MOUSEOVER()
        // this.START_NFC()
    },
    mounted(){
       
        
    },
    computed:{ 
        selectedCompany(){ 
            const re = store?.getters.getSelectedCompany
            return re
        }, 
        COMPANY_LINK(){
            return (link,isCompany,company_key)=>{ 
                if (!company_key) {
                    let selectedCompany = this.selectedCompany
                    company_key = selectedCompany?selectedCompany.key:null 
                }
                let index1 = link?link.includes("xxxx"):null
                let index2 = link?link.includes("XXXX"):null
                if(!link){return null}
                if (!isCompany) {return link}
                if (!company_key) {return null} 

                if (index1) {
                    const new_link = link.replace("xxxx",company_key)
                    return new_link  
                }else if (index2) {
                    const new_link = link.replace("XXXX",company_key)
                    return new_link  
                }else{
                    const new_link = "/"+company_key+link 
                    return new_link 
                }
            }
        },  
    }, 
    methods:{
        error(error){
            if(!error){return}
            let err = error.error?error.error:'...'
            let from = error.from?error.from:'...'
            let page = error.page?error.page:'...'
            store.dispatch('ERROR',{
                error:err,
                from:from,
                page:page
            })
        },
        ON_KEY_DOWN(){ 
            try {  
                if (!this.KEY_DOWN_STARTED) { 
                    this.KEY_DOWN_STARTED = true 
                    window.addEventListener("keydown", function(e) {
                       
                        // Record the key as pressed
                        const key = e.key.toLowerCase(); 
                        
                        if (!this.keysPressed) {
                            this.keysPressed = {};
                        }
                        this.keysPressed[key] = true;
                        if (e.ctrlKey && key === 's') {
                           e.preventDefault();
                        } else if (e.ctrlKey && e.shiftKey && key === 'i') {
                            return; 
                        } 
                        
                        if (this.keysPressed['control'] && this.keysPressed['s'] && this.keysPressed['t']) {
                            e.preventDefault(); // Stop the browser's "Save" dialog from opening
                            // Check for the specific combination: 
                            // 1. Control + s + i
                            console.log(this.keysPressed,'.........');
                            EventBus.$emit('ON_KEYBOARD_COMMAND',"control+s+t",this.keysPressed) 
                        }else if (this.keysPressed['control'] && this.keysPressed['s'] && this.keysPressed['i']) {
                            e.preventDefault(); // Stop the browser's "Save" dialog from opening
                            console.log(this.keysPressed,'.........');
                            EventBus.$emit('ON_KEYBOARD_COMMAND',"control+s+i",this.keysPressed) 
                        }



                        ///
                        let textInput = e.key  
                        const timeStamp = e.timeStamp; 
                        
                        // EventBus.$emit('ON_KEY_DOWN',textInput,timeStamp)
                        if (this.INPUT_TEXT == undefined||this.INPUT_TEXT == null||this.INPUT_TEXT == 'undefined') {
                            this.INPUT_TEXT = '' 
                        }if (this.INPUT_SPACIAL_KEYS == undefined||this.INPUT_SPACIAL_KEYS == null||this.INPUT_SPACIAL_KEYS == 'undefined') {
                            this.INPUT_SPACIAL_KEYS = []
                        }
                         


                        if (!this.INPUT_TIMER) {
                            this.INPUT_TIMER = moment().valueOf() 
                        } else {
                            let dif =toNumber(moment().valueOf())-toNumber(this.INPUT_TIMER) 
                            if (dif>100) {
                                this.INPUT_TEXT=''
                                this.INPUT_SPACIAL_KEYS=[]
                            } 
                            this.INPUT_TIMER = moment().valueOf() 
                        }

                        
                        
                        if (textInput==='Enter') { 
                            this.INPUT_SPACIAL_KEYS.push(textInput)
                            console.log(this.INPUT_TEXT,'ke,,,,,,,,,,');
                            EventBus.$emit('ON_QR_SCAN',this.INPUT_TEXT,this.INPUT_SPACIAL_KEYS,timeStamp) 
                            EventBus.$emit('ON_TYPING',this.INPUT_TEXT,this.INPUT_SPACIAL_KEYS,timeStamp) 
                            this.INPUT_TEXT=''
                            this.INPUT_SPACIAL_KEYS=[]
                            this.INPUT_NEW_TEXT = true 
                        }else if (textInput==='Shift') {
                            this.INPUT_SPACIAL_KEYS.push(textInput)   
                        }else if (textInput==='NumLock') {
                            this.INPUT_SPACIAL_KEYS.push(textInput) 
                        }else if (textInput==='CapsLock') {
                            this.INPUT_SPACIAL_KEYS.push(textInput) 
                        }else{ 
                            this.INPUT_TEXT = this.INPUT_TEXT+textInput
                            this.INPUT_NEW_TEXT = false
                        } 
                        // EventBus.$emit('ON_TYPING',this.textInput,timeStamp) 
                    })
                } 
            } catch (error) {
                this.error({
                    error:error,
                    from:'ON_KEY_DOWN',
                    page:NAME, 
                })  
            } 
        },
        ON_KEY_UP(){ 
            try {  
                if (!this.KEY_UP_STARTED) { 
                    this.KEY_UP_STARTED = true 
                    window.addEventListener("keyup", function(e) {
                        // Remove the key from the state when released
                        const key = e.key.toLowerCase();
                        delete this.keysPressed[key];

                        //
                        let textInput = e.key  
                        const timeStamp = e.timeStamp;  
                        EventBus.$emit('ON_KEY_UP',textInput,timeStamp)
                         
                         
                    })
                } 
            } catch (error) {
                this.error({
                    error:error,
                    from:'ON_KEY_UP',
                    page:NAME, 
                })  
            } 
        },
        ON_KEYBOARD_COMMAND(command,keys){ 
            try {  
                 console.log(command,keys,'CC......................');
                 
            } catch (error) {
                this.error({
                    error:error,
                    from:'ON_KEYBOARD_COMMAND',
                    page:NAME, 
                })  
            } 
        },
        ON_CLICK(){ 
            try {   
                window.addEventListener("click", function(e) { 
                    const timeStamp = e.timeStamp;  
                    EventBus.$emit('ON_CLICK',e,timeStamp) 
                })
            } catch (error) {
                this.error({
                    error:error,
                    from:'ON_CLICK',
                    page:NAME, 
                })  
            } 
        },
        ON_RIGHT_CLICK(){ 
            try {   
                window.addEventListener("contextmenu ", function(e) { 
                    const timeStamp = e.timeStamp;  
                    EventBus.$emit('ON_RIGHT_CLICK',e,timeStamp) 
                })
            } catch (error) {
                this.error({
                    error:error,
                    from:'ON_RIGHT_CLICK',
                    page:NAME, 
                })  
            } 
        },
        ON_DOUBLE_CLICK(){ 
            try {   
                window.addEventListener("dblclick ", function(e) { 
                    const timeStamp = e.timeStamp;  
                    EventBus.$emit('ON_DOUBLE_CLICK',e,timeStamp) 
                })
            } catch (error) {
                this.error({
                    error:error,
                    from:'ON_DOUBLE_CLICK',
                    page:NAME, 
                })  
            } 
        },
        ON_MOUSEOVER(){ 
            try {   
                window.addEventListener("mouseover", function(e) { 
                    const timeStamp = e.timeStamp;   
                    EventBus.$emit('ON_MOUSEOVER',e,timeStamp) 
                })
            } catch (error) {
                this.error({
                    error:error,
                    from:'ON_MOUSEOVER',
                    page:NAME, 
                })  
            } 
        }, 
        logError(error, from) {
        this.error({ error, from, page: NAME });
        }  
    },
    beforeDestroy() {
        // window.removeEventListener('keydown', this.ON_KEY_DOWN);
        // window.removeEventListener('keyup', this.ON_KEY_UP);
    },
    watch:{
         
    }
});
 